/**
 * ToolLibraryApi
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Indicates whether the authenticated user has accepted the currently effective terms and conditions version.
 */
export const AccountModuleEnumsTermsAcceptanceStatusDto = {
  Accepted: 'Accepted',
  Required: 'Required',
  UpcomingRequired: 'UpcomingRequired',
} as const;

export type AccountModuleEnumsTermsAcceptanceStatusDto =
  (typeof AccountModuleEnumsTermsAcceptanceStatusDto)[keyof typeof AccountModuleEnumsTermsAcceptanceStatusDto];
